// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btns[data-v-6022074f]{display:flex}.btns .btn_1[data-v-6022074f]{background-color:#666de8;border:none}.btns .btn_2[data-v-6022074f]{background-color:#f14866;border:none}", ""]);
// Exports
module.exports = exports;
